import React, { useCallback, useState } from 'react';
import cn from 'classnames';
import { saveAs } from 'file-saver';

import Table from 'Components/Table';
import Icon from 'Components/Icon/Icon';
import logoApprove from '../../../../assets/dm-approve.svg';
import logoDownload from '../../../../assets/dm-download.svg';
import logoPrint from '../../../../assets/dm-print.svg';
import formatDate from 'Shared/util/formatDate';
import formatPrice from 'Shared/util/formatPrice';
import CustomRowComponent from 'Components/CustomRowComponent/CustomRowComponent';

import { getOrder, getIssued, getTotal } from 'Shared/util/getColumns';

const TabQuotationsTable = ({ orders, approveQuoteMutation }) => {
  const [openDownMenu, setOpenDownMenu] = useState(null);

  const handleEvent = (event, payload) => {
    event.preventDefault();

    switch (payload.type) {
      case 'download':
        saveAs(payload.url, `${payload.title}.pdf`);
        break;
      case 'setOpenDownMenu':
        setOpenDownMenu(payload.id);
        break;
      case 'print':
        window.open(payload.url, 'PRINT', 'height=400,width=600');
        break;
      case 'approve':
        approveQuoteMutation({
          variables: {
            orderId: +payload.id,
          },
        });
        break;
      default:
        console.error(`Warning: there are no such options (${payload.type}) `);
    }
  };

  const columns = [
    getOrder(340),
    getIssued(170),
    getTotal(260),
    {
      cellProps: {
        Header: () => <span className="filter-title"> </span>,
        Cell: (props) => {
          const id = props.row._original.id;
          return (
            <>
              <span className="rt-td__head"> </span>
              <div className={'rt-td__cell'}>
                <div className="orders-tab-nav-container">
                  <button
                    data-testid="btn-points"
                    className="orders-tab-nav-container__btn-points"
                    onClick={(event) => handleEvent(event, { type: 'setOpenDownMenu', id })}
                  >
                    • • •
                  </button>
                  <div className="orders-tab-nav-container__btn-next">
                    <Icon name="icon-right" dataTestId={'icon-right-quotations'} />
                  </div>
                  <ul
                    data-testid="dropdown-menu"
                    className={cn('orders-tab-nav-container__dropdown-menu', { 'action-menu': id === openDownMenu })}
                    onMouseLeave={(event) => handleEvent(event, { type: 'setOpenDownMenu', id: null })}
                    onClick={(event) => event.preventDefault()}
                  >
                    <li>
                      <button onClick={(event) => handleEvent(event, { type: 'approve', id })}>
                        <img src={logoApprove} alt="approve" />
                        <span>Approve</span>
                      </button>
                    </li>
                    <li>
                      {props.row.download.url && (
                        <button
                          onClick={(event) =>
                            handleEvent(event, {
                              type: 'download',
                              url: props.row.download.url,
                              title: props.row.order.title,
                            })
                          }
                        >
                          <img src={logoDownload} alt="download" />
                          <span>Download</span>
                        </button>
                      )}
                    </li>
                    <li>
                      {props.row.download.url && (
                        <button onClick={(event) => handleEvent(event, { type: 'print', url: props.row.download.url })}>
                          <img src={logoPrint} alt="print" />
                          <span>Print</span>
                        </button>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </>
          );
        },
        accessor: 'download',
        width: 130,
        sortable: false,
      },
    },
  ];

  const mapColleaguesDataToRows = useCallback((orders = []) => {
    const filteredOrders = orders.map(({ order, issued, total, download, id }) => {
      return {
        order: {
          title: order.reference ? order.reference : '-',
          desc: order.slug ? order.slug : '-',
        },
        issued: {
          title: issued.date ? `${formatDate(issued.date)}` : '-',
        },
        total: {
          title: total.number && total.currency ? `${formatPrice(total.number)} ${total.currency}` : '-',
        },
        download: {
          url: download.url ? download.url : '',
        },
        id,
      };
    });

    return filteredOrders;
  }, []);

  const tableSettings = {
    paginationHeight: 56,
    pageSize: window.innerWidth > 767 ? 10 : 3,
    CustomRowComponent: (props) => <CustomRowComponent url={'/customer/order/detail/'} {...props} />,
  };

  return (
    <div className="tab-orders">
      {orders && (
        <div className="table-wrap" data-testid="tab-orders-table">
          <Table
            key="input-filter"
            sortable={false}
            tableSettings={tableSettings}
            columns={columns}
            data={mapColleaguesDataToRows(orders)}
          />
        </div>
      )}
    </div>
  );
};

export default TabQuotationsTable;
